
import { FeatureManagementKey } from '../../types';

export const featureManagement: Record<FeatureManagementKey, string> = {
  personalizations: 'Personalizations',
  personalization: 'Personalization',
  configureFeature: 'Configure Feature',
  featureConfigured: 'Feature Configured',
  featureNotConfigured: 'Not Configured',
  clickToEdit: 'Click to Edit',
  playbackControls: 'Playback Controls',
  contentOverlays: 'Content Overlays',
  appearance: 'Appearance',
  trackingEngagement: 'Tracking & Engagement',
  metrics: 'Metrics',
};
